import async from 'async';
import utils from '@/utils';

const list = (productId, commit, callback) => {
  utils.send({
    path: '/uploads/list',
    params: [productId],
    callback(data) {
      commit('list', data.list);
      callback(null);
    },
  });
};

export default {
  list: ({ state, commit }, productId) => {
    list(productId, commit, (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  upload: ({ state, commit }, { productId, file }) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/uploads/upload',
          params: [productId],
          files: {
            file: file,
          },
          callback(data) {
            utils.success('uploadsUpload');
            next(null);
          },
        });
      },
      (next) => { list(productId, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  delete: ({ state, commit }, { id, productId }) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/uploads/delete',
          params: [id],
          callback(data) {
            utils.success('uploadsDelete');
            next(null);
          },
        });
      },
      (next) => { list(productId, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },
};
